/**
 * @Description Report module saga/watcher file.
 * @FileName moduleWatcher.js
 * @Author Goutam Pal - pgoutam
 * @CreatedOn 26 Aug 22
 */
import { takeEvery, put, call, all } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { scsActionTypes } from '../actions/actionTypes';

import { exportErrorMsg, Logger, processError, renderFileName } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted,
  processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';
import { globalConstants } from '../../../../common/moduleConstants';

export function* getSCSExportList(action) {
  yield all([
    put(processingStarted()),
    put(getAction(scsActionTypes.RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.SCS_EXPORT,
      action.data,
    );
    const filename = renderFileName(responseData);
    const urlData = window.URL.createObjectURL(new Blob([responseData.data]));
    FileSaver(urlData, filename);
    yield put(processingCompleted());
  } catch (err) {
    if (err.response.status === globalConstants.errorCode402 || err.response.status === globalConstants.errorCode403) {
      const errorObject = exportErrorMsg(err.response.status);
      resetServerValue = { serverRequestError: errorObject };
    } else {
      resetServerValue = { serverRequestError: processError(err) };
    }
    yield all([
      put(getAction(scsActionTypes.RESET_SERVER_VALUE, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
}

export function* getSCSList(action) {
  Logger.verbose(`Action Detail For Get Gen Edit Type List : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(scsActionTypes.RESET_SERVER_VALUE, null)),
    put(getAction(scsActionTypes.LOG_SCS_LIST_REQUEST, action.data)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SCS_LIST, action.data);
    yield all([
      put(getAction(scsActionTypes.GET_SCS_LIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(scsActionTypes.RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(scsActionTypes.GET_SCS_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
}

// FF System Options
export function* getSystemOptions(action) {
  const { storeSetState } = action.data;
  yield all([
    put(processingStarted()),
    put(getAction(scsActionTypes.RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const payload = ['SOD_SYT_DT'];
    const responseData = yield call(invokeApi, moduleAPI.SYSTEM_OPTIONS_VIEW, payload);
    storeSetState({ sodSytDt: responseData[0].value });
    yield put(processingCompleted());
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    storeSetState([]);
    yield all([
      put(getAction(scsActionTypes.RESET_SERVER_VALUE, resetServerValue)),
      put(processingCompleted())]);
  }
}

function* scsModuleWatcher() {
  // Sales credit summary
  yield takeEvery(scsActionTypes.GET_SCS_LIST_REQUEST, getSCSList);
  yield takeEvery(scsActionTypes.GET_SCS_EXPORT_REQUEST, getSCSExportList);
  yield takeEvery(scsActionTypes.GET_SCS_SYSTEM_OPTIONS, getSystemOptions);
}

export default scsModuleWatcher;
